__turbopack_context__.v({
  "preview-modal": "_29g49q_preview-modal",
  "preview-modal__description-section": "_29g49q_preview-modal__description-section",
  "preview-modal__edit-button": "_29g49q_preview-modal__edit-button",
  "preview-modal__edit-button--selected": "_29g49q_preview-modal__edit-button--selected",
  "preview-modal__edit-icon": "_29g49q_preview-modal__edit-icon",
  "preview-modal__footer": "_29g49q_preview-modal__footer",
  "preview-modal__form-preview-items-list": "_29g49q_preview-modal__form-preview-items-list",
  "preview-modal__form-preview-section-heading": "_29g49q_preview-modal__form-preview-section-heading",
  "preview-modal__form-preview-section-title": "_29g49q_preview-modal__form-preview-section-title",
});
